export const SOFTLINE_PERMISSION_TIME_REPORT = 'TIMEREPORT';
export const SOFTLINE_PERMISSION_TIME_REPORT_PARTY = 'TIMEREPORT.GROUP';
